import pythonApiClient from './pythonBaseApi';

const basePath = '/mantenimientos/empresas';

export const empresaApi = {
  obtener: () => pythonApiClient.get(basePath),

  guardar: (data) => pythonApiClient.put(basePath, data),
};

export default empresaApi;
